import { Button, Dialog, DialogActions, DialogContent, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { useState } from "react";
import PaperDraggable from "../../../../../../components/PaperDraggable";
import SelectDepartamentoEstoqueMultiple from "../../../../../../components/SelectsSimpleApiQuery/SelectDepartamentoEstoque/Multiple";
import { TFiltrosProduto } from "../Listagem";
import SelectSetor from "../../../../../../components/SelectsSimpleApiQuery/SelectSetor";
import SelectEstoqueFabricantes from "../../../../../../components/SelectsSimpleApiQuery/SelectEstoqueFabricantes";
import SelectEstoqueCategorias from "../../../../../../components/SelectsSimpleApiQuery/SelectEstoqueCategorias";
import SelectTributacao from "../../../../../../components/SelectsSimpleApiQuery/SelectTributacao";

export default function DialogProdutoFilter({
    open,
    filtrosAtuais,
    onClose,
    onConfirm
}: DialogFiltrosNfsProps) {

    const [internalFilters, setInternalFilters] = useState<TFiltrosProduto>(filtrosAtuais);
    const handleInsertFiltros = (prop: string, value: any) => {
        setInternalFilters(prevState => ({ ...prevState, [prop]: value }))
    }

    const handleConfirm = (filters: TFiltrosProduto) => {

        onConfirm(filters)
        onClose()
    }

    const clearFiltros = () => {
        setInternalFilters({});
        onConfirm({});
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            title="Filtros"
            maxWidth="sm"
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogContent>

                <Typography variant="h6" mb={2}>Filtros</Typography>

                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <SelectDepartamentoEstoqueMultiple
                            value={internalFilters.departamento || []}
                            onChange={(dpto) => handleInsertFiltros("departamento", dpto)}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <SelectSetor
                            value={internalFilters.setor || []}
                            onChange={(setor) => handleInsertFiltros("setor", setor)}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <SelectTributacao
                            value={internalFilters.tributacao || null}
                            onChange={(tributacao) => handleInsertFiltros("tributacao", tributacao)}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <SelectEstoqueCategorias
                            value={internalFilters.categoria || []}
                            onChange={(categoria) => handleInsertFiltros("categoria", categoria)}
                            multiple
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <FormControl fullWidth>
                            <InputLabel id="tipo-label">Tipo</InputLabel>
                            <Select
                                labelId="tipo-label"
                                label="Tipo"
                                multiple
                                value={internalFilters.tipo || []}
                                onChange={(e) => handleInsertFiltros("tipo", typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
                                renderValue={(selected) => Array.isArray(selected) ? selected.map((val) => {
                                    switch (val) {
                                        case "P": return "Produto";
                                        case "S": return "Serviço";
                                        case "I": return "Ativo Imobilizado";
                                        case "C": return "Consumo";
                                        case "T": return "Produto Terceiro";
                                        default: return val;
                                    }
                                }).join(', ') : ""}
                            >
                                <MenuItem value="P">Produto</MenuItem>
                                <MenuItem value="S">Serviço</MenuItem>
                                <MenuItem value="I">Ativo Imobilizado</MenuItem>
                                <MenuItem value="C">Consumo</MenuItem>
                                <MenuItem value="T">Produto Terceiro</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={clearFiltros}>Limpar</Button>
                <Button variant="contained" onClick={() => handleConfirm(internalFilters)}>Aplicar</Button>
            </DialogActions>
        </Dialog>
    );
}

interface DialogFiltrosNfsProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (filters: TFiltrosProduto) => void;
    filtrosAtuais: TFiltrosProduto;
}